import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { compose } from 'recompose';
import bindReduceStore from '../../components/hocs/bindReduceStore.react';
import NewJobStore from '../../stores/NewJobStore';
import { JobPropTypes } from '../../util/helpers/SharedPropTypes';

import MainPage from '../../components/MainPage.react';
import JobForm from '../../components/job_form/JobForm.react';

const NewJob = ({ savedJob }) => (
  <MainPage>
    <h3>Create a new job</h3>

    <Row>
      <Col md={6} sm={12}>
        <JobForm savedJob={savedJob} />
      </Col>
    </Row>
  </MainPage>
);

NewJob.propTypes = {
  savedJob: JobPropTypes,
};

export default compose(
  bindReduceStore(NewJobStore, 'savedJob'),
)(NewJob);
